import { SingleStatBox } from './SingleStatBox';

export default SingleStatBox;
